<template>
  <div class='e-tab-wrap h-mmlTabs-content'>
    <div class='h-mml-scnrbox'>
      <div v-show='radioButtonShow' class='h-mml-radiobox'>
        <div class='h-mml-radmargin'>
          <ejs-radiobutton ref='singleRadioButton' :label="this.$t('MML.single')" checked=true name='default' @change='changeToSingle'></ejs-radiobutton>
        </div>
        <div class='h-mml-radmargin'>
          <ejs-radiobutton :label="this.$t('MML.mass')" name='default' @change='changeToMass'></ejs-radiobutton>
        </div>
      </div>
      <form :id='formId' onsubmit="return false">
        <div class="row h-mml-zxbtn">
          <div v-for='field in fields' :key='field.name' v-show='field.display' class='form-group col-lg-4'>
            <label><span v-show="field.validate.includes('required')" class='h-red-code'>*&nbsp;</span>{{ getFieldName(field) }}</label>
            <component ref='formItems' :is='field.plugin' :field='field' @update-data-cache='updateDataCache'></component>
          </div>
        </div>
      </form>
    </div>
    <div class='h-input-btns'>
      <ejs-button class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled' v-on:click.native='execMML'>{{$t('MML.execute')}}</ejs-button>
      <ejs-button class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled' v-on:click.native='generateMML2Cmd'>{{$t('MML.buildMML')}}</ejs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { FormValidator } from '@syncfusion/ej2-inputs';
import fieldGenerator from '../formItem/FormItemEntiy';
import FormInput from '../formItem/FormInput';
import FormSelect from '../formItem/FormSelect';
import MultiSelect from '../formItem/MultiSelect';
import packageParams from '@/components/mmlconfig/mixins/packageParams';
import formValidMixins from '@/mixin/mixin.js';
import { EventBus } from '@/plugins/eventBus.js';
import bus from '../bus.js';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'oper-form',
  components: {
    FormInput,
    FormSelect,
    MultiSelect
  },
  props: {
    formName: {
      type: String,
      default() {
        return '';
      },
    },
  },
  mixins: [packageParams, formValidMixins],
  data() {
    return {
      fields: [],
      value: 'Name',
      modVals: null,
      curModValue: null,
      // 修改时存放主键的集合 {主键1:value1,主键2：:value2,...}
      modPkList: {},
      // 修改时存放主键对应的field集合 {主键1:field1,主键2:field2,...}
      modPKFieldList: [],
      // 保存当前表单的值 {enname1:value1,enname2:value2,...}
      dataCache: {},
      radioButtonShow: false,
      options: {
        customPlacement: (inputElement, errorElement) => {
          const parentElement = inputElement.closest('.form-group');
          parentElement.appendChild(errorElement);
        },
        rules: {
        }
      },
      formRulesObj: {},
      formItemNames: [],
      formObj: {},
      cmdList: [],
    };
  },
  mounted() {
    this.formObj = new FormValidator(`#${this.formId}`, this.options);
  },
  computed: {
    ...mapGetters(['currentNode', 'currentMo', 'currentCommand', 'massModifyMode', 'massCheckedRecords', 'mmlOperButtonDisabled']),
    formId() {
      return `form4mml${this.formName}`;
    }
  },
  methods: {
    ...mapMutations(['changeCommand', 'changeMassModMode','changeMassChkedRecords']),
    getFieldName(field){
      return this.LOCALE === 'zh'?field.zname:field.ename;
    },
    changeToMass() {
      this.changeMassModMode(true);
      // 处理fields 1、隐藏主键项；2、加checkbox，同时field置disabled
      const fields = this.genFormFields();
      for (let i = fields.length - 1; i >= 0; i--) {
        const field = fields[i];
        // 批量修改时将主键attr设为隐藏，此处不予展示
        if (Object.keys(this.modPkList).includes(field.name)) {
          fields.splice(i, 1);
        }
        field.showCheckbox = true;
        field.disabled = true;
      }
      this.setFields(fields);
      // 当单条修改留有校验提示时，清空
      this.formObj.element.reset();
      // TODO 若有分支参数，则触发批量修改的分支参数
      if (this.currentMo.branch && this.currentMo.branch.length > 0) {
        // this.branchRequest(undefined, true);
      }
      // 切换的时候重新查询下 否则可能用旧数据
      this.getModVals();
    },
    changeToSingle() {
      this.modPkList = [];
      this.changeMassModMode(false);
      // 切换的时候重新查询下 否则可能用旧数据
      this.getModVals();
    },
    refreshFormTrigger(command) {
      this.changeCommand(command);
      this.initMassModeParams();
      if (command.name === 'MOD') {
        // await this.getModVals();
        // 触发changeToSingle函数
        this.changeToSingle();
      } else {
        // 非修改时清空element
        this.formObj.element.reset();
        this.$nextTick(() => {
          this.refreshFormFields();
        });
      }
    },
    refreshFormFields() {
      const fields = this.genFormFields();
      this.setFields(fields);
      if (this.currentMo.branch && this.currentMo.branch.length > 0) {
        this.branchRequest();
      }
    },
    getModVals() {
      const mmlQry = `QRY ${this.currentMo.moName} ;`;
      const cmdType = ['cluster', 'equipment', 'ne', 'short'];
      const data = {
        neId: this.currentNode.id,
        cmd: mmlQry,
        timeOut: 10,
        cmdType: cmdType.indexOf(this.currentNode.nodeType)
      };
      if (this.currentNode.nodeType === 'equipment') {
        data.equipmentIpId = this.findEquipmentIpId(this.currentNode, this.currentMo);
      }
      this.axios.post('/lte/ems/config/adv/executeMML', data).then(result => {
        const resultData = result.data.resultVal.data;
        if (resultData.result === 'FAIL') {
          this.modVals = null;
          this.refreshFormFields();
        }
        if (resultData.result === 'OK') {
          if (resultData.data && resultData.data.length > 0) {
            this.modVals = resultData.data;
          } else {
            this.modVals = null;
          }
        }
        if (this.massModifyMode) {
          bus.$emit('showMassModRecord', this.modVals);
        } else {
          if (this.modVals && this.modVals.length > 0) {
            this.showModFields();
          } else {
            this.refreshFormFields();
          }
        }
      });
    },
    // 第一次展示，若有主键，则只显示主键，若无主键，则正常显示
    showModFields() {
      const hasPrimaryKey = this.currentMo.attributes.some((attr) => (
        attr.isPrimaryKey === 'YES' && attr.isUsed.toLocaleUpperCase() === 'YES'
      ));
      if (hasPrimaryKey) {
        // 当有主键且待修改数据大于2条，显示批量修改
        if (this.modVals.length >= 2) {
          this.showBatchModRadioButton();
        }
        // this.modPkList = {};
        this.setFields(this.genPrimaryKeyFields());
      } else {
        const fields = this.genFormFields();
        // 遍历fields给每个field增加needMod属性
        this.setFields(fields, this.modVals[0]);
        if (this.currentMo.branch && this.currentMo.branch.length > 0) {
          this.branchRequest(this.modVals[0]);
        }
      }
    },
    showBatchModRadioButton() {
      if (this.allowToBatchMod()) {
        // 切换tab页后默认点击singleRadioButton
        this.$refs.singleRadioButton.click();
        this.radioButtonShow = true;
      }
    },
    // 触发表单刷新时，初始化批量修改相关参数
    initMassModeParams() {
      this.radioButtonShow = false;
    },
    /* V18A.0.11版本新增，当添加中存在修改没有的分支参数时，不支持批量修改 */
    allowToBatchMod() {
      let addCmd = null;
      let modCmd = null;
      this.currentMo.commands.forEach(cmd => {
        if (cmd.name === 'ADD') {
          addCmd = cmd;
        }
        if (cmd.name === 'MOD') {
          modCmd = cmd;
        }
      });
      // 当不存在新增命令时，不需要存储
      if (addCmd === null || addCmd.params.length <= 0) {
        return true;
      }
      const addUniqueBranch = [];
      addCmd.params.forEach(param => {
        if (this.currentMo.branch
            && this.currentMo.branch.indexOf(param.name) >= 0) {
          addUniqueBranch.push(param.name);
        }
      });
      if (modCmd.params.length > 0) {
        modCmd.params.forEach(param => {
          const index = addUniqueBranch.indexOf(param.name);
          if (index >= 0) {
            addUniqueBranch.splice(index, 1);
          }
        });
      }
      return addUniqueBranch.length <= 0;
    },
    genPrimaryKeyFields() {
      const fields = [];
      let index = 0;
      this.currentMo.attributes.forEach((attr) => {
        if (attr.isPrimaryKey === 'YES'
                    && attr.isUsed.toLocaleUpperCase() === 'YES') {
          // 记录主键的key
          this.modPkList[attr.name] = this.modPkList[attr.name] ? this.modPkList[attr.name] : '';
          const ranges = [{ name: '', value: '' }];
          this.modVals.forEach(modVal => {
            const temRange = { name: modVal[attr.name], value: modVal[attr.name] };
            if (JSON.stringify(ranges).indexOf(JSON.stringify(temRange)) < 0) {
              ranges.push(temRange);
            }
          });
          const field = {
            zname: attr.zhName,
            ename: attr.enName,
            name: attr.name,
            plugin: 'form-select',
            type: 'Enum',
            // TODO 修改词条
            validate: '{"required": [true, "MML.notNull"]}',
            vals: ranges,
            placeholder: '',
            def: null,
            func: null,
            pkfunc: this.showWholeFormFieldsTrigger,
            asc: ++index
          };
          this.modPKFieldList[attr.name] = field;
          fields.push(field);
        }
      });
      return fields;
    },
    // 修改主键时触发全部表单回填
    showWholeFormFieldsTrigger(pkName, pkValue) {
      if (pkValue) {
        this.modPkList[pkName] = pkValue;
      }
      this.modVals.forEach(modVal => {
        let showWholeFormFields = true;
        // 当当前所有主键值与某一条修改值一致时，触发全部表单回填
        Object.keys(this.modPkList).forEach(modPk => {
          if (modVal[modPk] !== this.modPkList[modPk]) {
            showWholeFormFields = false;
          }
        });
        if (showWholeFormFields) {
          // 修改时也按适配包中定义的顺序展示mml表单字段 --add by s18857 fix td 21689
          const fields = this.genFormFields();
          const pkFields = this.genPrimaryKeyFields();
          const finalFields = [];
          fields.forEach((field, index) => {
            if (this.modPkList[field.name] === undefined) {
              field.needMod = true;
              field.asc = index;
              finalFields.push(field);
            } else {
              const pKField = pkFields.find(pkField => (pkField.name === field.name));
              finalFields.push(pKField);
            }
          });
          this.setFields(finalFields, modVal);
          if (this.currentMo.branch && this.currentMo.branch.length > 0) {
            this.branchRequest(modVal);
          }
        }
      });
    },
    branchRequest(modVal, disableAttrBranch) {
      const branches = this.currentMo.branch;
      // 将每个触发分支的当前值保存起来
      const branchAttr = {};
      let key = `${this.currentMo.moName}_branchAttr_`;
      branches.forEach(branch => {
        if (this.dataCache[branch]) {
          key += this.dataCache[branch];
          branchAttr[branch] = this.dataCache[branch];
        } else if (modVal && modVal[branch]) {
          key += modVal[branch];
          branchAttr[branch] = modVal[branch];
        }
      });
      if (JSON.stringify(branchAttr) === '{}') {
        return;
      }
      const moBranchCache = JSON.parse(localStorage.getItem(`${this.currentNode.typeCode}_${this.currentNode.softwareVersion}`));
      if (moBranchCache[key]) {
        const attrbranchLst = moBranchCache[key];
        Object.keys(attrbranchLst).forEach(attrbranch => {
          this.dynamicChange(attrbranch, attrbranchLst[attrbranch], disableAttrBranch);
        });
      } else {
        const params = this.packageMoBranchParams(this.currentNode, this.currentMo);
        params.moAttrLst = branchAttr;
        this.axios.post('/lte/ems/config/mml/getMoBranchAttrLst', params).then(res => {
          const moBranchRes = res.data.resultVal;
          if (moBranchRes && moBranchRes.reactAttr) {
            const attrbranchLst = JSON.parse(moBranchRes.reactAttr.RspAttrProp);
            moBranchCache[key] = attrbranchLst;
            localStorage.setItem(`${this.currentNode.typeCode}_${this.currentNode.softwareVersion}`, JSON.stringify(moBranchCache));
            Object.keys(attrbranchLst).forEach(attrbranch => {
              this.dynamicChange(attrbranch, attrbranchLst[attrbranch], disableAttrBranch);
            });
          }
        });
      }
    },
    // 批量修改时的分支动态内容处理 V18A.0.11版本增加disableAttrBranch参数,当触发分支为disable时，动态分支也置为disable
    dynamicChange(attrName, dynamicObject, disableAttrBranch) {
      // 当触发分支为disable时，动态分支也置为disable, 同时去掉required标识
      if (disableAttrBranch) {
        dynamicObject = {};
        dynamicObject.isDisabled = true;
      }
      const field = this.getField(attrName);
      if (!field) {
        return;
      }
      // 隐藏动态分支参数的checkbox
      if (this.massModifyMode) {
        field.showCheckbox = false;
      }
      Object.keys(dynamicObject).forEach(dynamicKey => {
        // formDynamicChange[dynamicKey](field, dynamicObject);
        this.dynamicChangeDispatcher(dynamicKey, field, dynamicObject);
      });
      // 设置完校验规则后，需要重新绑定下表单验证
      // this.$nextTick(() => {
      //   this.formObj = new FormValidator(`#${this.formId}`, this.options);
      // });
      this.setFormValidator();
    },
    dynamicChangeDispatcher(dynamicKey, field, dynamicObject) {
      const dynamicChangeProxy = {
        defaultVal: this.changeDefaultVal,
        isDisabled: this.changeDisabledState,
        isRequired: this.changeRequiredState,
        isHidden: this.changeHiddenState,
        scope: this.changeScopeState,
      };
      const dynamicChangeFun = dynamicChangeProxy[dynamicKey];
      dynamicChangeFun(field, dynamicObject);
    },
    changeDefaultVal(field, attrLst) {
      // weblmt在mod模式时依然赋默认值
      // if (this.currentCommand.name !== 'MOD') {
      field.def = attrLst.defaultVal;
      this.dataCache[field.name] = field.def;
      // }
    },
    changeDisabledState(field, attrLst) {
      field.disabled = attrLst.isDisabled;
      const rules = this.parseValidateToRules(field.validate);
      if (rules.required) {
        delete rules.required;
        this.formRulesObj[field.name] = rules;
        // this.formObj.addRules(field.name, rules);
        field.def = '';
        if (field.vals) {
          field.vals.unshift({ name: '', value: '' });
        }
        field.validate = JSON.stringify(rules);
        this.dataCache[field.name] = field.def;
      }
    },
    changeRequiredState(field, attrLst) {
      const rules = this.parseValidateToRules(field.validate);
      if (attrLst.isRequired) {
        rules.required = true;
        field.disabled = false;
        field.display = true;
        if (field.vals) {
          field.vals.shift();
        }
      } else if (rules.required) {
        delete rules.required;
        if (field.vals) {
          field.vals.unshift({ name: '', value: '' });
        }
      }
      this.formRulesObj[field.name] = rules;
      field.validate = JSON.stringify(rules);
      this.dataCache[field.name] = field.def;
    },
    changeHiddenState(field, attrLst) {
      field.display = !attrLst.isHidden;
      if (attrLst.isHidden) {
        const rules = this.parseValidateToRules(field.validate);
        if (rules.required) {
          delete rules.required;
          field.validate = JSON.stringify(rules);
          this.formRulesObj[field.name] = rules;
          // this.formObj.addRules(field.name, rules);
          field.def = '';
          if (field.vals) {
            field.vals.unshift({ name: '', value: '' });
          }
          this.dataCache[field.name] = field.def;
        }
      }
    },
    changeScopeState(field, attrLst) {
      switch (field.type) {
        case 'Enum': {
          const attrs = this.currentMo.attrMap;
          if (attrs[field.ename].isPrimaryKey !== 'YES') {
            const ranges = [];
            const { validate } = field;
            const rules = this.parseValidateToRules(field.validate);
            if (!rules.required) {
              ranges.push({ name: '', value: '' });
            }
            attrLst.scope.map(range => ranges.push({ name: range, value: range }));
            field.vals = ranges;
          }
          break;
        }
        case 'Text': {
          const rules = this.parseValidateToRules(field.validate);
          // rules.maxLength = [attrLst.scope.maxLen, this.$t('MML.maxLength', [attrLst.scope.maxLen])];
          rules.maxLengthValue = attrLst.scope.maxLen;
          rules.maxLength = this.maxBytesValidateFn;
          field.placeholder = this.$t('MML.maxBytesLength', [attrLst.scope.maxLen]);
          field.validate = JSON.stringify(rules);
          // this.formObj.addRules(field.name, rules);
          this.formRulesObj[field.name] = rules;
          break;
        }
        case 'Number': {
          const rules = this.parseValidateToRules(field.validate);
          rules.range = [attrLst.scope.min, attrLst.scope.max];
          field.placeholder = `${attrLst.scope.min} ~ ${attrLst.scope.max}`;
          field.validate = JSON.stringify(rules);
          // this.formObj.addRules(field.name, rules);
          this.formRulesObj[field.name] = rules;
          break;
        }
        default:
          break;
      }
      this.dataCache[field.name] = field.def;
    },
    // 生成表单字段
    genFormFields() {
      if (this.currentCommand == null) {
        return [];
      }
      const attrs = this.currentMo.attributes;
      const [params, fields] = [[], []];
      this.currentCommand.params.forEach(param => params.push(param));
      if (params.length <= 0) {
        return [];
      }
      params.forEach((param, index) => {
        const formItemAttr = {};
        formItemAttr.index = index;
        let isBranch = false;
        if (this.currentMo.branch && this.currentMo.branch.includes(param.name)) { isBranch = true; }
        formItemAttr.func = isBranch ? this.branchRequest : null;
        formItemAttr.validate = param.uiValidate;
        formItemAttr.attr = attrs.find(attr => attr.name === param.name);
        formItemAttr.defValue = param.defValue !== 'NA' ? param.defValue : null;
        formItemAttr.isForeign = [null, 'NA', 'NO', ''].indexOf(formItemAttr.attr.foreignKey) < 0;
        // TODO by 18857 需要根据国际化判断取param中的哪个参数作为表单项展示的名字
        const attrUnit = formItemAttr.attr.unit.trim();
        const unit = attrUnit === null || attrUnit === 'NA' || attrUnit === '' ? '' : '('+attrUnit+')';
        formItemAttr.zname = param.zhName + unit;
        formItemAttr.ename = param.enName + unit;
        formItemAttr.name = param.name;
        // 个别表单项需验证该项
        formItemAttr.notNull = param.notNull;
        // 生成表单field，并加到fields数组里
        const fieldType = formItemAttr.attr.dataType.toLowerCase();
        if (fieldGenerator[fieldType]) {
          fields.push(fieldGenerator[fieldType](formItemAttr));
        } else {
          fields.push(fieldGenerator.default(formItemAttr));
        }
      });
      return fields || [];
    },
    setFields(fields, modValue) {
      if (fields.length === 0) {
        this.clearFields();
        return;
      }
      this.formRulesObj = {};
      this.formItemNames = [];
      // TODO by s18857 后续需加赋初始值过程
      fields.forEach(field => {
        field.plugin = field.plugin || 'form-input';
        field.asc = field.asc || 0;
        field.placeholder = field.placeholder || '';
        field.display = field.display || true;
        field.disabled = field.disabled || false;
        field.fullrow = field.fullrow || false;
        field.linefeed = field.linefeed || false;
        field.validate = field.validate || '';
        field.func = field.func || null;
        field.needMod = field.needMod || false;
        // -------------------批量修改Mo V18A.0.11版本增加----------------------- //
        field.showCheckbox = field.showCheckbox || false;
        field.checked = field.checked || false;
        // $this.isModLst[field.ename] = false;
        field.def = field.def || '';
        if (modValue && modValue[field.name]) {
          if (field.plugin === 'multi-select') {
            const multiDef = modValue[field.name].split(',');
            field.def = multiDef;
          } else {
            field.def = modValue[field.name];
          }
        }
        this.dataCache[field.name] = field.def;
        // 设置表单Fields时，顺便设置表单校验
        try {
          this.formRulesObj[field.name] = this.parseValidateToRules(field.validate);
        } catch (err) {
          console.warn(`mml校验规则转换失败，mo名称：${this.currentMo.moName}，失败表单项名称：${field.name}, 该项校验为：${field.validate}`);
        }
        if (!field.disabled) {
          this.formItemNames.push(field.name);
        }
      });
      console.log('fields:', fields);
      this.fields = fields;
      this.setFormValidator();
    },
    setFormValidator() {
      this.$nextTick(() => {
        this.formObj = this.validateForm(this.formId, this.formItemNames, this.formRulesObj, this.options.customPlacement);
      });
    },
    removeFormItemAndSetFormValidator(formItemName) {
      const index = this.formItemNames.indexOf(formItemName);
      this.formItemNames.splice(index,1);
      this.setFormValidator();
    },
    addFormItemAndSetFormValidator(formItemName) {
      this.formItemNames.push(formItemName);
      this.setFormValidator();
    },
    parseValidateToRules(validateStr) {
      if (validateStr === '') {
        return;
      }
      const validateObj = JSON.parse(validateStr);
      Object.keys(validateObj).forEach(validateKey => {
        // 如果validateObj[validateKey]的数组长度大于2个，则说明校验提示词条有占位符
        if (validateKey === 'maxLength'){
          validateObj.maxLengthValue = validateObj[validateKey][0];
          validateObj[validateKey] = this.maxBytesValidateFn;
        } else if (validateKey === 'minLength') {
          validateObj.minLengthValue = validateObj[validateKey][0];
          validateObj[validateKey] = this.minBytesValidateFn;
        } else {
          validateObj[validateKey] = validateObj[validateKey][0];
        }
      });
      return validateObj;
    },
    clearFields() {
      this.fields = [];
    },
    getField(fieldname) {
      return this.fields.find(field => field.name === fieldname);
    },
    updateDataCache(fieldName, fieldVal) {
      this.dataCache[fieldName] = fieldVal;
    },
    generateMML2Cmd() {
      this.cmdList = [];
      if (this.doValidateForm()) {
        if (this.massModifyMode) {
          this.genMassMML();
        } else {
          this.genSingleMML();
        }
        bus.$emit('add2CmdEditor', this.cmdList);
      } else {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('MML.validateFailed')});
        console.warn('mml表单校验不通过');
      }
    },
    execMML() {
      this.cmdList = [];
      if (this.doValidateForm()) {
        if (this.massModifyMode) {
          this.genMassMML();
        } else {
          this.genSingleMML();
        }
        // 执行逻辑在CommandExec组件中实现
        this.$emit('ready-to-exec', this.cmdList);
      } else {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('MML.validateFailed')});
        console.warn('mml表单校验不通过');
      }
    },
    doValidateForm() {
      return this.formObj.validate();
    },
    genSingleMML() {
      const params = this.getFormDataMap();
      const mml = this.parseParams2MML(params);
      this.cmdList.push(mml);
    },
    genMassMML() {
      if (this.massCheckedRecords.length <= 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('MML.noCheck')});
        return;
      }
      if (this.massCheckedRecords.length > 100) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('MML.atMost100')});
        return;
      }
      const params = this.getFormDataMap();
      this.massCheckedRecords.forEach(record => {
        const mml = this.parseParams2MassMML(params, record);
        this.cmdList.push(mml);
      });
    },
    getFormDataMap() {
      const formData = {};
      this.fields.forEach((field) => {
        if (field.display) {
          formData[field.name] = this.dataCache[field.name];
        }
      });
      return formData;
    },
    parseParams2MML(params) {
      // 匹配数值  "" ^\\d+(\.\\d+)?$
      const numberExp = new RegExp('^-?\\d+(\\.\\d+)?$');
      let mml = `${this.currentCommand.name} ${this.currentMo.moName} :`;
      if (this.currentNode) {
        mml += ` ne= ${this.currentNode.id} ,`;
      }
      if (this.currentNode.nodeType === 'equipment') {
        const equipmentIpId = this.findEquipmentIpId(this.currentNode, this.currentMo);
        mml += ` equipmentIpId= ${equipmentIpId} ,`;
      }
      Object.keys(params).forEach(param => {
        if (params[param] !== '') {
          if (numberExp.test(params[param]) || params[param] === 'null' || params[param] === '"null"') {
            mml += ` ${param} = ${params[param]},`;
          } else {
            mml += ` ${param} = "${params[param]}",`;
          }
        }
      });
      return `${mml.substring(0, mml.length - 1).trim()} ;`;
    },
    parseParams2MassMML(params, record) {
      // 匹配数值  "" ^\\d+(\.\\d+)?$
      const numberExp = new RegExp('^-?\\d+(\\.\\d+)?$');
      let mml = `${this.currentCommand.name} ${this.currentMo.moName} :`;
      if (this.currentNode) {
        mml += ` ne= ${this.currentNode.id} ,`;
      }
      if (this.currentNode.nodeType === 'equipment') {
        const equipmentIpId = this.findEquipmentIpId(this.currentNode, this.currentMo);
        mml += ` equipmentIpId= ${equipmentIpId} ,`;
      }
      Object.keys(this.modPkList).forEach(pkParam => {
        mml += ` ${pkParam} = ${record[pkParam]},`;
      });
      Object.keys(params).forEach(param => {
        if (params[param] !== '') {
          if (numberExp.test(params[param]) || params[param] === 'null' || params[param] === '"null"') {
            mml += ` ${param} = ${params[param]},`;
          } else {
            mml += ` ${param} = "${params[param]}",`;
          }
        }
      });
      return `${mml.substring(0, mml.length - 1).trim()} ;`;
    }
  },
};
</script>

<style>

</style>
